/**
 * Job Posted Date Menu
 */

import { ChevronDownIcon, ChevronUpIcon, CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { jobPayloadState, savedJobPayloadState } from "_state/atoms/AppAtoms";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { SecondaryButton } from "../HJSButton";
import { datePostedFilter } from "config/Consts";
import { FC, useState } from "react";

const PostedDate: FC<{ index?: number }> = ({ index }) => {
  const location = useLocation();
  const isJobSearch = location.pathname === "/jobs/search";

  const [showX, setShowX] = useState(false);
  const [payload, setPayload] = useRecoilState(jobPayloadState);
  const [savedJobPayload, setSavedJobPayload] =
    useRecoilState(savedJobPayloadState);

  const getPayload = isJobSearch ? payload : savedJobPayload;
  const updatePayload = isJobSearch ? setPayload : setSavedJobPayload;

  return (
    <Menu matchWidth={true}>
      {({ isOpen, onClose }) => (
        <>
          <MenuButton
            as={SecondaryButton}
            fontSize={{ base: 14, md: 16 }}
            borderLeft="2px solid white"
            borderRadius="initial"
            rightIcon={
              isOpen ? (
                <ChevronUpIcon className="fill-white" />
              ) : (
                <ChevronDownIcon className="fill-white" />
              )
            }
            maxHeight="1.5rem"
            background="transparent !important"
          >
            <Text color="white">Posted Date</Text>
          </MenuButton>
          <MenuList
            backgroundColor="teal.600"
            color="white"
            minW="initial"
            border="none"
          >
            {Object.values(datePostedFilter).map((value) => (
              <MenuItem
                key={value}
                backgroundColor={
                  getPayload.postedDate === value
                    ? "hjsSecondaryHover !important"
                    : "teal.600 !important"
                }
                fontSize={{ base: 14, md: 16 }}
                fontWeight="semibold"
                _hover={{ backgroundColor: "hjsSecondaryHover !important" }}
                // _focus={{ backgroundColor: "hjsSecondaryHover" }}
                onClick={() => {
                  if (getPayload.postedDate !== value) {
                    !showX && setShowX(true);
                    updatePayload((prev: any) => ({
                      ...prev,
                      postedDate: value,
                      // enabled: false,
                      page: 1,
                    }));
                  }
                }}
              >
                {value >= 36500 ? "All" : `${value} days`}
              </MenuItem>
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  );
  // );
};

export default PostedDate;
